import PreviewerContext from '@apphiveio/controlsmanager/PreviewerContext'
import React, { useContext } from 'react'

type Props = {
  style?: {
    width?: number
    height?: number
  }
}

const PreviewerLottieApphiveLoading: React.FC<Props> = ({ style }) => {
  const {
    Render,
    lottieSources: { apphiveLoading },
  } = useContext(PreviewerContext)

  if (!apphiveLoading) {
    return null
  }

  return (
    <Render.View style={style}>
      <Render.Lottie source={apphiveLoading} visible loop />
    </Render.View>
  )
}

export default PreviewerLottieApphiveLoading
